<template>
  <div>
    <el-form class="selectlesson">
      <el-form-item label="选择网校">
        <el-select
          clearable
          v-model="model.maID"
          @change="getTests"
          placeholder="网校"
        >
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          clearable
          v-model="model.chID"
          @change="getCourse"
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item clearable label="二级分类">
        <el-select
          clearable
          v-model="model.coID"
          @change="getClass"
          placeholder="二级分类"
        >
          <el-option
            clearable
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="三级分类">
        <el-select
          clearable
          v-model="model.clID"
          @change="getTests"
          multiple
          placeholder="三级分类"
        >
          <el-option
            v-for="item in shclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <template v-show="tableData">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column
          prop="createAt"
          label="日期"
          :formatter="formatDate"
          width="150"
        >
        </el-table-column>
        <el-table-column prop="testsName" label="名称"> </el-table-column>
        <el-table-column prop="grade" label="班次" width="120">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.grade" :key="tag.index">
              <el-tag style="margin: 3px" v-show="tag.grName">{{
                tag.grName
              }}</el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="grade" label="价格" width="70">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.grade" :key="tag.index">
              <el-tag style="margin: 3px" v-show="tag.grPrice">{{
                tag.grPrice
              }}</el-tag>
            </span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="95">
          <template slot-scope="scope">
            <el-button
              style="margin: 3px 3px 3px 3px"
              @click="delTests(scope.row)"
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              >删除</el-button
            >
            <el-button
              style="margin: 3px 3px 3px 3px"
              tag="router-link"
              target="_blank"
              @click="editTest(scope.row._id)"
              type="primary"
              size="small"
              icon="el-icon-edit"
              plain
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </template>
    <el-skeleton :loading="loading" :rows="10" animated />
    <!--  grade分类分页 -->
    <div class="grade-page">
      <el-pagination
        @size-change="changeSize"
        @current-change="currentChange"
        :current-page="currentPage"
        @prev-click="lessonpre"
        @next-click="lessonnext"
        background
        layout="prev, pager, next,total,jumper,sizes"
        :total="testsLength"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { timerfilter } from "../util/timerfilter";
//import moment from 'moment'

export default {
  data() {
    return {
      major: [],
      channel: [],
      course: [],
      shclass: [],
      tableData: [],
      lesson: [],
      model: {},

      loading: true,
      isShow: false,

      changesums: {},

      testsLength: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  methods: {
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel(item) {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getCourse(item) {
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID: item },
        });
        this.course = getcourse.data;
        this.getTests(item);
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(item) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID: item },
        });
        this.shclass = getclass.data;
        this.getTests(item);
      } catch (error) {
        console.log(error);
      }
    },
    async getTests() {
      try {
        const result = await this.$http.get("/tests/gettests", {
          params: {
            maID: this.model.maID,
            chID: this.model.chID,
            coID: this.model.coID,
            clID: this.model.clID,
            page: this.currentPage,
            size: this.pageSize,
          },
        });
        this.tableData = result.data[0].result;
        this.testsLength = result.data[0].resultLength[0].totalCount;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    /* 编辑课程 */
    async editTest(id) {
      window.open(`/tests/edit/${id}`, "_blank");
    },

    /* async findBooks(item) {
      const onelesson = await this.$http.get(
        "/category/addcontent?_id=" + `${item._id}`
      );
      this.addlesson = onelesson.data;
    }, */

    async delTests(item) {
      this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(async () => {
          const res = await this.$http.delete(
            "/tests/deltests?_id=" + `${item._id}`
          );

          if (res.status === 203) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.getTests();
          } else {
            this.$message(res.message);
          }
        })
        .catch((res) => {
          if (res === "cancel") {
            this.$message({
              type: "info",
              message: "取消删除",
            });
          } else {
            //console.log(res);
            this.$message({
              type: "info",
              message: res.message,
            });
          }
        });
    },
    formatDate(row, column) {
      let date = row[column.property];
      if (date == null) {
        return null;
      }
      //console.log(date)
      return timerfilter(date); //moment(date).format('YYYY-MM-DD HH:mm')
    },

    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    //lesson分类分页
    async lessonpre() {
      this.currentPage--;

      //this.getTertiary(this.pageSize);
      //console.log("上一页");
    },
    async lessonnext() {
      this.currentPage++;
      // this.getTertiary(this.pageSize);
      //console.log(this.pageSize);
    },
    async changeSize(size) {
      this.pageSize = size;
    },
    async currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getTests(this.currentPage);
      //console.log(this.currentPage);
    },
  },
  created() {
    this.getMajor();
    this.getChannel();
    this.getTests();
  },
};
</script>

<style scoped>
.selectlesson {
  display: flex;
  justify-content: space-between;
}
.editBooks {
  display: flex;
  justify-content: space-between;
}
</style>
>
